(function ($) {

    var pluginName = 'ygmTooltip';

    function YgmTooltip(element, options) {
        this.init(element, options);
    }

    YgmTooltip.prototype = {

        init: function (element, options) {
            var self = this;

            self.$element = $(element);
            self.options = $.extend({
                position: 'top',
                gap: 5
            }, options);

            self.$panel = $('<div class="ygm-tooltip ygm-tooltip--' + self.options.position + '"></div>');
            self.$inner = $('<div class="ygm-tooltip_inner"></div>').html(self.$element.data('title'));
            self.$tail = $('<div class="ygm-tooltip_tail"></div>');

            self.$panel.append(self.$inner).append(self.$tail).hide();

            self.$element.after(self.$panel);

            self.$element.on('mouseenter focus', function () {
                self.$panel.fadeIn();
                self.setPosition();
            });

            self.$element.on('mouseleave focusout', function () {
                if (self.$element.is(':focus')) return;
                self.$panel.fadeOut();
            });
        },

        setPosition: function () {
            var self = this;

            var pH = self.$panel.outerHeight();
            var pW = self.$panel.outerWidth();

            var eH = self.$element.outerHeight();
            var eW = self.$element.outerWidth();

            var eT = self.$element.offset().top;
            var eL = self.$element.offset().left;

            var hO = (eH - pH) / 2;
            var wO = (eW - pW) / 2;

            switch (self.options.position) {
                case 'left':
                    self.$panel.offset({top: eT + hO, left: eL - pW - self.options.gap});
                    break;
                case 'right':
                    self.$panel.offset({top: eT + hO, left: eL + eW + self.options.gap});
                    break;
                case 'bottom':
                    self.$panel.offset({top: eT + eH + self.options.gap, left: eL + wO});
                    break;
                default:
                    self.$panel.offset({top: eT - pH - self.options.gap, left: eL + wO});
            }
        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new YgmTooltip(this, options));
            }
        });
    }

})(jQuery);